export enum ErrorCodes {
  SC_EXCEEDED_ITEM_COUNT = 'SC_EXCEEDED_ITEM_COUNT',
  SC_MAX_PRODUCTS_IN_CART_ERROR = 'SC_MAX_PRODUCTS_IN_CART_ERROR',
}
